import { defineMessages } from 'react-intl';

export default defineMessages({
  clear: {
    id: 'baukasten.Form.InputFieldClearButton.clear',
    defaultMessage: 'Clear',
  },
});
